import {
  deleteSupportUser,
  getSupportRoleList,
  getSupportUsers,
  saveSupportRoleUsers,
} from '../../../api/admin/rbac';
import { messageInfo } from '../../../components/message';
import { RbacRoleType } from '../../../model';
import { store } from '../../../store';

export const memberQuit = async () => {
  const { userInfo } = store.getState().common;
  const supportMembers = await getSupportUsers();
  const roles = await getSupportRoleList();
  if (!supportMembers || !roles) {
    return false;
  }
  const matchedMember = supportMembers.find(
    (item) => item.UserID === userInfo?.UserID
  );
  if (!userInfo || !matchedMember) {
    return false;
  }
  let operateRes = false;

  const isOwner = roles
    .find((item) => item.type === RbacRoleType.Owner)
    ?.userList.includes(userInfo.UserID);
  if (isOwner) {
    messageInfo('请先移交超级管理员权限');
    return;
  }

  const res = await Promise.all(
    roles
      .filter((roleItem) => roleItem.userList.includes(userInfo.UserID))
      .map(async (roleItem) => {
        return saveSupportRoleUsers({
          operator: userInfo.UserID,
          userIdList: roleItem.userList.filter(
            (name) => name !== userInfo.UserID
          ),
          roleId: roleItem.roleId,
        });
      })
  );

  operateRes = res.every(Boolean);
  if (operateRes) {
    operateRes = await deleteSupportUser(matchedMember.id);
  }
  return operateRes;
};
